/** Options for hiking profile and trail forms */

export const HIKER_EXPERIENCE_LEVELS = [
  { value: 'BEGINNER', label: 'Beginner (short, flat trails)' },
  { value: 'INTERMEDIATE', label: 'Intermediate (comfortable with roots, rocks, and some climb)' },
  { value: 'ADVANCED', label: 'Advanced (long days and steep grades)' },
  { value: 'EXPERT', label: 'Expert (backpacking, scrambling, all-day routes)' },
];

export const TRAIL_DIFFICULTIES = [
  { value: 'EASY', label: 'Easy' },
  { value: 'MODERATE', label: 'Moderate' },
  { value: 'HARD', label: 'Hard' },
  { value: 'STRENUOUS', label: 'Strenuous' },
];

export const TRAIL_TERRAINS = [
  { value: 'PAVED', label: 'Paved' },
  { value: 'GRAVEL', label: 'Gravel' },
  { value: 'DIRT', label: 'Dirt' },
  { value: 'ROCKY', label: 'Rocky' },
  { value: 'MIXED', label: 'Mixed' },
];

export const TRAIL_ROUTE_SHAPES = [
  { value: 'LOOP', label: 'Loop' },
  { value: 'OUT_AND_BACK', label: 'Out and back' },
  { value: 'POINT_TO_POINT', label: 'Point to point' },
];

export const HIKER_GROUP_PREFERENCES = [
  { value: 'SOCIAL', label: 'Social (easy pace, lots of stops)' },
  { value: 'FITNESS', label: 'Fitness (steady pace, fewer breaks)' },
  { value: 'SUMMIT', label: 'Summit (distance and elevation focused)' },
];

export const OUTING_PACE_GROUPS = [
  { value: 'RELAXED', label: 'Relaxed' },
  { value: 'STEADY', label: 'Steady' },
  { value: 'BRISK', label: 'Brisk' },
];

/** Starting point for an organizer's pack list; they can edit before publishing. */
export const DEFAULT_PACK_LIST = [
  '2L water',
  'Trail snacks',
  'Rain layer',
  'Headlamp',
  'First aid kit',
];

const labelFor = (options, value) =>
  options.find((option) => option.value === value)?.label || value || '—';

export function formatHikerExperience(value) {
  return labelFor(HIKER_EXPERIENCE_LEVELS, value);
}

export function formatTrailDifficulty(value) {
  return labelFor(TRAIL_DIFFICULTIES, value);
}

export function formatTrailTerrain(value) {
  return labelFor(TRAIL_TERRAINS, value);
}

export function formatTrailRouteShape(value) {
  return labelFor(TRAIL_ROUTE_SHAPES, value);
}

export function formatHikerGroupPreference(value) {
  return labelFor(HIKER_GROUP_PREFERENCES, value);
}

export function formatOutingPace(value) {
  return labelFor(OUTING_PACE_GROUPS, value);
}

/** Distances are stored in km; hikers here mostly think in miles. */
export function formatDistance(distanceKm) {
  if (distanceKm == null || Number.isNaN(Number(distanceKm))) return '—';
  const km = Number(distanceKm);
  const miles = km * 0.621371;
  return `${km} km (${miles.toFixed(1)} mi)`;
}

export function formatElevation(elevationGainM) {
  if (elevationGainM == null || Number.isNaN(Number(elevationGainM))) return '—';
  const meters = Number(elevationGainM);
  const feet = Math.round(meters * 3.28084);
  return `${meters} m (${feet} ft) climb`;
}

export function formatDuration(minutes) {
  if (!minutes || Number.isNaN(Number(minutes))) return '—';
  const total = Number(minutes);
  const hours = Math.floor(total / 60);
  const mins = total % 60;
  if (!hours) return `${mins} min`;
  return mins ? `${hours} hr ${mins} min` : `${hours} hr`;
}
